import { useQuery } from '@tanstack/react-query';
import type { ApiClients } from '@/api/client';
import type { components } from '@/api/types/api-gateway';

export type FleetOverview = components['schemas']['FleetOverview'];

function unwrap<T>(data: T | undefined, error: unknown, what: string): T {
  if (error || !data) {
    const msg = (error as { error?: string } | undefined)?.error ?? `${what} failed`;
    throw new Error(msg);
  }
  return data;
}

export function useFleetOverview(clients: ApiClients) {
  return useQuery({
    queryKey: ['reporting', 'fleet-overview'],
    queryFn: async (): Promise<FleetOverview> => {
      const { data, error } = await clients.apiGateway.GET('/v1/reporting/fleet-overview');
      return unwrap(data, error, 'fleet-overview');
    },
    staleTime: 60_000,
  });
}
